<template>
  <div class="main" v-if="formData.merchantNum">
    <el-form-item label="Master A/C" prop="merchantNum">
      {{ formData.merchantNum }}
    </el-form-item>
    <!-- <cc-form :config="commonConfig" v-model="tabData" ref="form1" labelWidth="250px" :rules="rules" size="medium"></cc-form> -->
    <!-- 公司名稱（英文） -->
    <el-form-item :label="language('shopInformation.nameEng')" prop="nameEng">
      {{ formData.nameEng }}
    </el-form-item>
    <!-- label="公司名稱（中文）" -->
    <el-form-item :label="language('shopInformation.nameChi')" prop="nameChi">
      {{ formData.nameChi }}
    </el-form-item>
    <!-- label="公司註冊地" -->
    <el-form-item
      :label="language('shopInformation.registerArea')"
      prop="registerArea"
    >
      {{ formData.registerArea }}
    </el-form-item>
    <!-- label="公司註冊證編號" -->
    <el-form-item
      :label="language('shopInformation.registerNum')"
      prop="registerNum"
    >
      {{ formData.registerNum }}
    </el-form-item>
    <!-- 商業登記證地址 -->
    <h3>{{ language("shopInformation.addressInfo") }}</h3>
    <el-divider></el-divider>
    <!-- label="國家" -->
    <el-form-item :label="language('shopInformation.country')" prop="country">
      {{ formData.country }}
    </el-form-item>
    <!-- label="區域" -->
    <el-form-item :label="language('shopInformation.region')" prop="region">
      {{ formData.region }}
    </el-form-item>
    <!-- label="地址" -->
    <el-form-item :label="language('shopInformation.street')" prop="street">
      {{ formData.street }}
    </el-form-item>
    <!-- label="室號" -->
    <el-form-item :label="language('shopInformation.room')" prop="room">
      {{ formData.room }}
    </el-form-item>
    <!-- label="商業登記證編號" -->
    <el-form-item
      :label="language('shopInformation.brCertificateNum')"
      prop="brCertificateNum"
    >
      {{ formData.brCertificateNum }}
    </el-form-item>
    <!-- label="商業登記證" -->
    <el-form-item
      :label="language('shopInformation.brCertificateUrl')"
      prop="brCertificateUrl"
    >
      <!-- <FormUploader v-model="formData.brCertificateUrl" /> -->

      <!-- <el-image
        v-for="(items, index) in brCertificateUrl(formData)"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="items.link"
        :preview-src-list="items.link"
      >
      </el-image> -->
      <div v-for="(items, index) in brCertificateUrl(formData)">
        <span style="margin-right: 20px"
          >{{ items.name }}
          <a :href="items.link" target="_blank" class="link">
            {{ language("shopInformation.download") }}
          </a>
        </span>
      </div>
    </el-form-item>
    <!-- label="BR Expiry Date" -->
    <el-form-item
      :label="language('shopInformation.brExpiryDate')"
      prop="brExpiryDate"
    >
      {{ formData.brExpiryDate }}
    </el-form-item>
    <!-- label="公司簡介" -->
    <el-form-item
      :label="language('shopInformation.introductionUrl')"
      prop="introductionUrl"
    >
      <!-- <FormUploaderFile v-model="formData.introductionUrl" /> -->

      <div v-for="(items, index) in introductionUrl(formData)">
        <span style="margin-right: 20px"
          >{{ items.name }}
          <a :href="items.link" target="_blank" class="link">
            {{ language("shopInformation.download") }}
          </a>
        </span>
      </div>
    </el-form-item>
    <!-- label="公司電子郵件" -->
    <el-form-item
      :label="language('shopInformation.businessEmail')"
      prop="businessEmail"
    >
      {{ formData.businessEmail }}
    </el-form-item>

    <!-- <h3>聯絡人</h3> -->
    <h3>{{ language("shopInformation.contact") }}</h3>
    <el-divider></el-divider>
    <!-- label="姓氏" -->
    <el-form-item
      :label="language('shopInformation.contactLastName')"
      prop="contactLastName"
    >
      {{ formData.contactLastName }}
    </el-form-item>
    <!-- label="名稱" -->
    <el-form-item
      :label="language('shopInformation.contactFirstName')"
      prop="contactFirstName"
    >
      {{ formData.contactFirstName }}
    </el-form-item>
    <!-- label="職位" -->
    <el-form-item
      :label="language('shopInformation.contactPosition')"
      prop="contactPosition"
    >
      {{ formData.contactPosition }}
    </el-form-item>
    <!-- label="部門" -->
    <el-form-item
      :label="language('shopInformation.contactDepartment')"
      prop="contactDepartment"
    >
      <!-- <FormCheckboxGroup v-model="formData.contactDepartment" /> -->
      {{ contactDepartment(formData) }}
    </el-form-item>
    <!-- label="電郵地址（供登入使用）" -->
    <el-form-item
      :label="language('shopInformation.contactEmail')"
      prop="contactEmail"
    >
      {{ formData.contactEmail }}
    </el-form-item>
    <!-- label="手機號碼" -->
    <el-form-item
      :label="language('shopInformation.contactPersonalPhone')"
      prop="contactPersonalPhone"
    >
      {{ formData.contactPersonalPhone }}
    </el-form-item>
    <!-- label="辦公電話號碼" -->
    <el-form-item
      :label="language('shopInformation.officePhoneNumber')"
      prop="officePhoneNumber"
    >
      {{ formData.officePhoneNumber }}
    </el-form-item>
    <!-- label="傳真" -->
    <el-form-item :label="language('shopInformation.fax')" prop="fax">
      {{ formData.fax }}
    </el-form-item>

    <!-- <h3>商店及商品資料</h3> -->
    <h3>{{ language("shopInformation.product") }}</h3>
    <el-divider></el-divider>
    <!-- label="商店名稱"  -->
    <el-form-item :label="language('shopInformation.shopName')" prop="shopName">
      {{ formData.shopName }}
    </el-form-item>
    <!-- label="商店別名（英文）" -->
    <el-form-item
      :label="language('shopInformation.shopNameEng')"
      prop="shopNameEng"
    >
      {{ formData.shopNameEng }}
    </el-form-item>
    <!-- label="銷售商品類別" -->
    <el-form-item
      :label="language('shopInformation.productCategory')"
      prop="productCategory"
    >
      {{ productCategory(formData) }}
      <!-- 只显示不改变 -->
      <!-- <FormDisplayList :value="formData.productCategory" /> -->
    </el-form-item>
    <!-- label="銷售產品數量" -->
    <el-form-item
      :label="language('shopInformation.productSaleCount')"
      prop="productSaleCount"
    >
      <!-- 只显示不改变 -->
      {{ formData.productSaleCount }}
    </el-form-item>
    <!-- label="是否接受推廣信息" -->
    <el-form-item
      :label="language('shopInformation.isAgreeHktv')"
      prop="isAgreeHktv"
    >
      <label>{{ formData.isAgreeHktv == 1 ? "同意" : "不同意" }}</label>
    </el-form-item>

    <!-- <h3>商業登記證地址</h3>
    <el-divider></el-divider>
    <cc-form :config="businessConfig" v-model="tabData" ref="form2" labelWidth="250px" :rules="rules" size="medium"></cc-form>
    <h3>聯絡人</h3>
    <el-divider></el-divider>
    <cc-form :config="contactConfig" v-model="tabData" ref="form3" labelWidth="250px" :rules="rules" size="medium"></cc-form>
    <h3>商店及商品資料</h3>
    <el-divider></el-divider>
    <cc-form :config="productConfig" v-model="tabData" ref="form4" labelWidth="250px" :rules="rules" size="medium"></cc-form> -->
  </div>
</template>
<script>
import FormDisplay from "./FormDisplay";
import FormDisplayList from "./FormDisplayList";
import FormUploader from "./FormUploader";
import FormUploaderFile from "./FormUploaderFile";
import FormCheckboxGroup from "./FormCheckboxGroup";

// 设置options

export default {
  model: {
    prop: "formData",
    event: "change",
  },
  props: {
    formData: Object,
  },
  components: {
    FormDisplay,
    FormDisplayList,
    FormUploader,
    FormUploaderFile,
    FormCheckboxGroup,
  },
  methods: {
    productCategory(data) {
      let category = {
        Books: "Books (圖書)",
        "Children’s Books": "Children’s Books (兒童圖書)",
        "Textbooks & Workbooks": "Textbooks & Workbooks (教參練習)",
        Stationary: "Stationary (文具)",
        "Toys & Gifts": "Toys & Gifts (玩具精品)",
        Electronics: "Electronics (電子產品)",
        "Food & Wellness": "Food & Wellness (食品)",
        "Fitness & Travel": "Fitness & Travel (運動及旅遊)",
        Others: "Others (其他)",
      };
      let text = "";
      let textArr = [];
      data.productCategory = JSON.stringify(["Books", "Others"]);
      if (data.productCategory != "") {
        // text = JSON.parse(data.productCategory).join("、");
        text = JSON.parse(data.productCategory);
        for (let i = 0; i < text.length; i++) {
          if (category[text[i]]) {
            textArr.push(category[text[i]]);
          } else {
            textArr.push(text[i]);
          }
        }
      }
      return textArr.join("、");
    },
    contactDepartment(data) {
      let department = {
        "Sales & Marketing Department":
          "Sales & Marketing Department (市場營銷部)",
        "Top Management": "Top Management (管理層)",
        "Warehouse and Operation Department":
          "Warehouse and Operation Department (倉務及營運部)",
        "Finance & Accounting Department":
          "Finance & Accounting Department (財務及會計部)",
        "Other Department": "Other Department (其他)",
      };

      let text = [];
      let textArr = [];
      if (data.contactDepartment != "") {
        // text = JSON.parse(data.contactDepartment).join("、");
        text = JSON.parse(data.contactDepartment);
        for (let i = 0; i < text.length; i++) {
          if (department[text[i]]) {
            textArr.push(department[text[i]]);
          } else {
            textArr.push(text[i]);
          }
        }
      }
      return textArr.join("、");
    },
    brCertificateUrl(data) {
      let text = [];
      if (data.brCertificateUrl != "") {
        text = JSON.parse(data.brCertificateUrl);
      }
      return text;
    },
    introductionUrl(data) {
      let text = [];
      if (data.introductionUrl != "") {
        text = JSON.parse(data.introductionUrl);
      }
      return text;
    },
  },
};
</script>
<style scoped lang="scss">
.input {
  width: 200px;
}
.banner {
  width: 200px;
}
.location {
  margin-bottom: 20px;
  display: flex;
  width: 500px;
  .title {
    width: 100px;
  }
  .value {
    margin-left: 10px;
    width: 300px;
  }
}
.link {
  color: red;
}
.main {
  max-width: 1000px;
}
</style>
